import React from "react";
import {Typography} from "antd";

import PageInfoLayout from "@/components/PageInfoLayout/PageInfoLayout";

export default function SignUpSuccessful(): JSX.Element {
  return (
    <PageInfoLayout>
      <Typography.Title level={2}>Registration successful!</Typography.Title>
      <Typography.Paragraph className="content">
        Your account has been created.
        <br />
        You will receive an email with instructions for confirming your email address in a few minutes.
      </Typography.Paragraph>
    </PageInfoLayout>
  );
}
